/**
 * Maps backend error codes from /v1/platform/auth/* 4xx responses
 * onto user-facing English copy. Kept in its own file (no React
 * exports) so Vite Fast Refresh can hot-reload auth.tsx cleanly
 * (rule `react-refresh/only-export-components`).
 */
export function authErrorMessage(code: string): string {
  switch (code) {
    case "invalid_credentials":
      return "Email or password is wrong.";
    case "mfa_required":
      return "Multi-factor auth isn't supported in this version yet. Contact your admin.";
    case "user_locked":
      return "Your account is locked. Contact your admin.";
    case "session_expired":
      return "Sign-in session expired. Please try again.";
    case "user_exists":
      return "An account with this email already exists. Sign in instead.";
    case "weak_password":
      return "Password is too weak. Use at least 8 characters with upper- and lower-case letters, a number, and a symbol.";
    case "idp_failed":
      return "Sign-in with that provider didn't complete. Please try again.";
    case "rate_limited":
      return "Too many attempts — try again in a minute.";
    case "validation_failed":
      return "Please double-check the form and try again.";
    case "network_error":
      return "Couldn't reach the server. Check your connection.";
    default:
      return "Sign-in failed. Try again.";
  }
}
